var DeeplinkBonusParams = /* @__PURE__ */ ((DeeplinkBonusParams2) => {
  DeeplinkBonusParams2["bonusId"] = "bonusId";
  return DeeplinkBonusParams2;
})(DeeplinkBonusParams || {});
var CustomPromotionsEvent = /* @__PURE__ */ ((CustomPromotionsEvent2) => {
  CustomPromotionsEvent2["login"] = "login";
  CustomPromotionsEvent2["registration"] = "registration";
  CustomPromotionsEvent2["navigate"] = "navigate";
  CustomPromotionsEvent2["terms"] = "terms";
  CustomPromotionsEvent2["pwaInstall"] = "pwa-install";
  return CustomPromotionsEvent2;
})(CustomPromotionsEvent || {});
var BonusStageClasses = /* @__PURE__ */ ((BonusStageClasses2) => {
  BonusStageClasses2["lose"] = "lose";
  BonusStageClasses2["win"] = "win";
  BonusStageClasses2["expired"] = "pending";
  BonusStageClasses2["notActivated"] = "returned";
  return BonusStageClasses2;
})(BonusStageClasses || {});
export {
  BonusStageClasses,
  CustomPromotionsEvent,
  DeeplinkBonusParams
};
